module.exports = __webpack_public_path__ + "static/media/landing-background.604ab742.webp";